import React, { Component } from "react";
import Slider, { Range } from "rc-slider";
import "rc-slider/assets/index.css";

class HeadSlider extends Component {
  render() {
    return (
      <div>
        <Slider min={1} max={6} dots onChange={(value) => this.props.handleUpdateValue(value)} />
      </div>
    );
  }
}

export default HeadSlider;



// WEBPACK FOOTER //
// ./src/components/slider.js